import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import AboutUs from './pages/AboutUs';
import ContactUs from './pages/ContactUs';
import AmenitiesPage from './pages/AmenitiesPage';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
  <Route path="/about" element={<AboutUs />} />
  <Route path="/contact" element={<ContactUs />} />
    <Route path="/amenities" element={<AmenitiesPage />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
